import { Component } from 'react';
import { Perform } from './perform';
import { camelCaseToTitleCase } from '@servicetitan/form';

interface PerformSelectProps<T> {
    name: string;
    value?: number | undefined;
    enumType: T;
}

export class PerformEnumSelect<T extends { [key: number]: string }> extends Component<
    PerformSelectProps<T>
> {
    render() {
        const { value, name, enumType } = this.props;
        const text = value != null ? camelCaseToTitleCase(enumType[value]) : '';
        return <Perform name={name} text={text} />;
    }
}
